import {createAction} from 'redux-actions'
import {createSplits} from '@rambler-id/ab-splits'
import {sentryReact as Sentry} from '@rambler-id/sentry'
import {isOriginInvalid} from '@rambler-id/url'
import {GET_CONFIGURATION} from '@rambler-id/transport'
import {apiV3} from 'utils/transport'
import {createSelectQuery} from 'containers/App/selectors'

const NOT_ALL_DATA_IS_DISPLAYED =
  'По техническим причинам отображены не все данные. При необходимости перезагрузите страницу.'

export const updateUrlQuery = createAction('UPDATE_URL_QUERY')
export const updateAllowedDomains = createAction('UPDATE_ALLOWED_DOMAINS')
export const updateAllowedSchemas = createAction('UPDATE_ALLOWED_SCHEMAS')
export const updateVariations = createAction('UPDATE_VARIATIONS')
export const showSnackbar = createAction(
  'SHOW_SNACKBAR',
  (message) => message,
  (_, meta) => meta
)

export const throwError = createAction(
  'THROW_ERROR',
  (message) => message,
  (_, error) => error
)

export const loadAllowedDomains = () => async (dispatch, getState) => {
  const back = createSelectQuery('back')(getState())
  let domains = null

  if (back) {
    try {
      const {configuration} = await apiV3(`/legacy/${GET_CONFIGURATION}`, {
        key: 'AllowedRedirectDomains'
      })

      domains = configuration
    } catch (error) {
      if (error.code === 0 || error.code === -17) {
        dispatch(throwError(NOT_ALL_DATA_IS_DISPLAYED, error))

        return
      }

      Sentry.captureException(error)
    }
  }

  dispatch(updateAllowedDomains(domains))
}

export const loadAllowedSchemas = () => async (dispatch, getState) => {
  const schema = createSelectQuery('redirect_to_scheme')(getState())
  let schemas = null

  if (schema) {
    try {
      const {configuration} = await apiV3(`/legacy/${GET_CONFIGURATION}`, {
        key: 'AllowedRamblerIdRedirectSchemasV2'
      })

      schemas = configuration
    } catch (error) {
      if (error.code === 0 || error.code === -17) {
        dispatch(throwError(NOT_ALL_DATA_IS_DISPLAYED, error))

        return
      }

      Sentry.captureException(error)
    }
  }

  dispatch(updateAllowedSchemas(schemas))
}

export const loadAbSplits = () => async (dispatch) => {
  try {
    const response = await window.fetch('//id.rambler.ru/ab-config/common.json')
    const config = await response.json()
    const splits = createSplits(config)

    dispatch(updateVariations(splits.getVariations()))
  } catch (error) {
    Sentry.captureException(error)
    dispatch(throwError(NOT_ALL_DATA_IS_DISPLAYED))
  }
}

export const checkEmbedding = () => async (dispatch) => {
  if (isOriginInvalid(window.location.href)) {
    dispatch(
      throwError(
        'Внимание! Вы пытаетесь войти в сервисы Rambler&Co через небезопасный сайт! Ваши логин и пароль могут стать доступны третьим лицам.'
      )
    )
  }
}
